import { SYS_MSG as TYPES, USER_MSG_TYPES } from 'constants';

export const SYSTEM_MSG = {
  [TYPES.GROUP_CREATED]: () => 'Welcome! Share this code to invite users to this group',
  [TYPES.GROUP_UPDATED]: () => 'Group info has been updated',
  [TYPES.GROUP_CLOSED]: () => 'Joining to the group is now closed by the admin',
  [TYPES.GROUP_OPENED]: msg => `Joining is re-opened! Share code " ${msg.data.code} " to invite users to the group`,
  [TYPES.USER_JOINED]: msg => `${msg.user.name} has joined the group`,
  [TYPES.USER_REJOINED]: msg => `${msg.user.name} has re-joined the group`,
  [TYPES.MAKE_ADMIN]: msg => `${msg.data.name} is now an admin`,
  [TYPES.UNMAKE_ADMIN]: msg => `${msg.data.name} is no longer an admin`,
  [TYPES.USER_LEFT]: msg => `${msg.user.name} has left the group`,
  [TYPES.ADD_TASK]: msg => `"${msg.data.title}" is added to Tasks`,
  [TYPES.UPDATE_TASK]: msg => `"${msg.data.title}" is updated in Tasks`,
  [TYPES.REMOVE_TASK]: msg => ` "${msg.data.title}" is removed from Tasks`,
  [TYPES.ADD_MATERIAL]: msg => (msg.data.length === 1 ? `"${msg.data[0].name}" is added to Materials` : `${msg.data.length} new Materials are added`),
  [TYPES.REMOVE_MATERIAL]: msg => `"${msg.data.name}" is removed from Materials`,
  [TYPES.UPDATE_MATERIAL]: msg => `"${msg.data.name}" is updated in Materials`,
  [TYPES.MEMBER_BLOCKED]: msg => `"${msg.data.name}" was blocked from this group`,
  [TYPES.MEMBER_UNBLOCKED]: msg => `"${msg.data.name}" was unblocked from this group`,
  [TYPES.MEMBER_REMOVED]: msg => `"${msg.data.name}" was removed from this group`,
  [TYPES.GROUP_AVATAR_CHANGED]: msg => `${msg.user.name} has changed the group avatar`
};

export const SYSTEM_LAST_MSG = {
  [TYPES.GROUP_CREATED]: msg => `${msg.user.name} created a group`,
  [TYPES.GROUP_UPDATED]: () => 'Group info has been updated',
  [TYPES.GROUP_CLOSED]: () => `Joining to this group is closed`,
  [TYPES.GROUP_OPENED]: () => `Joining is re-opened`,
  [TYPES.USER_JOINED]: msg => `${msg.user.name} joined the group`,
  [TYPES.USER_REJOINED]: msg => `${msg.user.name} has re-joined the group`,
  [TYPES.MAKE_ADMIN]: msg => `${msg.data.name} is now an admin`,
  [TYPES.UNMAKE_ADMIN]: msg => `${msg.data.name} is no longer an admin`,
  [TYPES.USER_LEFT]: msg => `${msg.user.name} left the group`,
  [TYPES.ADD_TASK]: msg => `${msg.user.name} added a task`,
  [TYPES.UPDATE_TASK]: msg => `${msg.user.name} updated a task`,
  [TYPES.REMOVE_TASK]: msg => `${msg.user.name} removed a task`,
  [TYPES.ADD_MATERIAL]: msg => `${msg.user.name} added a material`,
  [TYPES.REMOVE_MATERIAL]: msg => `${msg.user.name} removed a material`,
  [TYPES.UPDATE_MATERIAL]: msg => `${msg.user.name} updated a material`,
  [TYPES.MEMBER_BLOCKED]: msg => `"${msg.data.name}" was blocked from this group`,
  [TYPES.MEMBER_UNBLOCKED]: msg => `"${msg.data.name}" was unblocked from this group`,
  [TYPES.MEMBER_REMOVED]: msg => `"${msg.data.name}" was removed from this group`,
  [TYPES.GROUP_AVATAR_CHANGED]: msg => `Group avatar has changed`
};

const UPLOAD = {
  VIDEO: 'Uploading video',
  PHOTO: 'Uploading photo'
};

export const USER_LAST_MSG = {
  [USER_MSG_TYPES.DELETED]: 'This message was deleted',
  [USER_MSG_TYPES.VIDEO]: 'Video',
  [USER_MSG_TYPES.PHOTO]: 'Photo',
  [USER_MSG_TYPES.UPLOAD]: msg => UPLOAD[msg.upload_type],
  [USER_MSG_TYPES.LOCATION]: 'Location',
  [USER_MSG_TYPES.CONTACT]: 'Contact'
};
export const DELETED_MSG = 'You deleted this message';

export const NOTIFICAION_BASE_FOOTER = name => `By ${name} at `;



// WEBPACK FOOTER //
// ./src/lang/en/messages.js